export default __webpack_public_path__ + "static/media/ads.5beb916f.png";